/**
 * Global Style
 * Global styling applied everywhere in app
 */
import type { Theme } from '@mui/material';
import 'react-phone-number-input/style.css';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
  html {
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }
  
  input {
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  fieldset {
    padding: 0 0 20px;
    border: 0;
    width: 100%;
    box-sizing: border-box;
  }

  h1 {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  h2 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 24px;
    line-height: 32px;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-weight: 300;
  }

  h3 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 19px;
    line-height: 26px;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-weight: 500;
  }

  h4 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.3px;
    line-height: 21px;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    text-transform: uppercase;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.info.main};
  }

  a:hover {
    color: ${({ theme }) => theme.palette.info.main}99;
  }

  form {
    width: 100%;
  }

  ol {
    padding-inline-start: 1em;
  }

  .MuiCard-root, .MuiDialogContent-root {
    .MuiFormLabel-root {
      color: ${(props) => props.theme.palette.primary.main};
      }
      }
      
  .error-msg {
    color: ${(props) => props.theme.palette.error.main};
    font-size: 12px;
  }
`;
